export default function ravenHttpInterceptor($provide, $httpProvider) {
  'ngInject';

  // Log HTTP response errors to Sentry
  $provide.factory('ravenHttpInterceptor', ($q, errorTrackingService) => {
    'ngInject';
    return {
      responseError: (rejection) => {
        // Ignore http error for status 4xx except Bad requests
        const { config, status, data } = rejection;
        if (status <= 499 && status !== 400) {
          return $q.reject(rejection);
        }
        const headers = rejection.headers();
        const requestID = headers ? headers['x-request-id'] : '';
        const originalMessage = data.originalMessage;

        const sentryMessage = new Error(
          `HTTP Error: X-Request-ID ${requestID} with message ${
            originalMessage || data.message
          }`,
        );

        errorTrackingService.captureException(sentryMessage, {
          extra: {
            config: config,
            status: status,
            data: data,
            requestID: requestID,
            httpErrorMessage: originalMessage,
          },
        });
        return $q.reject(rejection);
      },
    };
  });

  $httpProvider.interceptors.push('ravenHttpInterceptor');
}
